module.exports = __webpack_public_path__ + "static/media/renewal.00586753.svg";